defineDs('DanskeSpil/Domain/NumberGames/Scripts/Helpers/NumberGamesDictionary',
  [
    'Shared/Framework/Mithril/Scripts/Helpers/Dictionary'
  ],
  function (Dictionary) {

    return new Dictionary('/NumberGames');

  });
